import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Center, Flex, Heading, Text, } from "@reverb-ui/react";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import PopUpDisabledIcon from "@/assets/icons/pop-up-disabled.svg";
export var PopupDisabled = function () { return (React.createElement(Center, { h: "100vh" },
    React.createElement(Flex, { direction: "column", alignItems: "center" },
        React.createElement(PopUpDisabledIcon, null),
        React.createElement(Heading, { as: "h1", fontSize: "xl", mt: "5" }, "Pop-ups are disabled in your browser"),
        React.createElement(Text, { mt: "3" }, "Please, enable it to login"),
        React.createElement(Accordion, { width: "500px", mt: 6 },
            React.createElement(AccordionItem, null,
                React.createElement("h2", null,
                    React.createElement(AccordionButton, { py: 4 },
                        React.createElement(Box, { flex: "1", textAlign: "left", fontSize: "lg" }, "How to enable it on Google Chrome"),
                        React.createElement(AccordionIcon, null))),
                React.createElement(AccordionPanel, { pb: 4 },
                    React.createElement(Text, null,
                        "Click the three dots in the top right corner of your screen ",
                        ">",
                        " ",
                        "select ",
                        React.createElement("b", null, "Settings"),
                        " ",
                        ">",
                        " Scroll down and tap",
                        " ",
                        React.createElement("b", null, "Site Settings"),
                        " ",
                        ">",
                        " tap Pop-ups and redirects ",
                        ">",
                        " ",
                        "Finally, turn the toggle for ",
                        React.createElement("b", null, "Pop-ups and redirects"),
                        " off."))),
            React.createElement(AccordionItem, null,
                React.createElement("h2", null,
                    React.createElement(AccordionButton, { py: 4 },
                        React.createElement(Box, { flex: "1", textAlign: "left", fontSize: "lg" }, "How to enable it on Mozilla Firefox"),
                        React.createElement(AccordionIcon, null))),
                React.createElement(AccordionPanel, { pb: 4 },
                    "Click the menu button Menu and select Options ",
                    ">",
                    " select the Privacy & Security panel ",
                    ">",
                    " under the Permissions section, uncheck the box next to Block pop-up windows to disable the pop-up blocker altogether.")),
            React.createElement(AccordionItem, null,
                React.createElement("h2", null,
                    React.createElement(AccordionButton, { py: 4 },
                        React.createElement(Box, { flex: "1", textAlign: "left", fontSize: "lg" }, "How to enable it on Opera"),
                        React.createElement(AccordionIcon, null))),
                React.createElement(AccordionPanel, { pb: 4 },
                    "Click the Menu (Red `O` in the top left) and click Settings ",
                    ">",
                    " ",
                    "expand the Advanced Menu and select Privacy & security ",
                    ">",
                    " locate and select Content settings ",
                    ">",
                    " scroll and select Pop-ups and redirects ",
                    ">",
                    " toggle the Allowed button as desired.")))))); };
